import { getSocket } from './socket'

// OSPROD-RT-PUSH: thin pub/sub wrapper over the socket's
// `mail:event:changed` frame. Consumers subscribe + return cleanup;
// the listener is wired exactly once per page load.

// Two producers reach this channel (see packages/server-sdk/src/bosEvents.ts):
//   • Python BOS  → kind 'new'|'updated'|'deleted'|'flagged', ALWAYS with a
//                   messageId (and usually a threadId).
//   • @os/mail's sync worker → kind 'sync', account-level, NO per-message id
//                   (it fires once per finished sync pass, not per message).
// `messageId` is therefore optional. Treat 'sync' as "refetch the list";
// never count it as a message and never key a cache off its ids.
export interface MailEventChanged {
  kind: 'new' | 'updated' | 'deleted' | 'flagged' | 'sync'
  /** Python path only — absent on `kind:'sync'`. */
  messageId?: number
  threadId?: number
  /** Module path only — the mail account whose sync produced the frame. */
  accountId?: string
  /** Module path only — ISO timestamp of the emit. */
  at?: string
}

type Listener = (e: MailEventChanged) => void
const listeners = new Set<Listener>()
let wired = false

function ensureWired(): void {
  if (wired) return
  const socket = getSocket()
  socket.on('mail:event:changed', (payload: MailEventChanged) => {
    for (const fn of listeners) fn(payload)
  })
  wired = true
}

export function subscribeMailEvents(fn: Listener): () => void {
  ensureWired()
  listeners.add(fn)
  return () => { listeners.delete(fn) }
}
